import { LoadingOutlined } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { handleAllocationsSave } from '@components/Reports/DispatchDirective/util'
import { addCommasToNumber, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'

import { PaceMetric } from '../PaceMetric'
import { ClickTextEdit } from './ClickTextEdit'

export function WeeklyRow({ directive, updateRow, setIsExpanded }) {
  const { viewingWeekly } = useDirectiveContext()
  const [isRefreshing, setIsRefreshing] = useState(false)
  const { scopes } = useSecurityContext()
  const { selectedDate } = useDirectiveContext()
  const canEditDirectives =
    scopes.supply_directive.supply_view.edit && moment(selectedDate).isAfter(moment().startOf('day'))

  if (!viewingWeekly) return null

  const onSave = (e) =>
    handleAllocationsSave(e.target.value, directive, 'weekly_percent', updateRow, setIsRefreshing, setIsExpanded)
  return (
    <Horizontal height={30}>
      <Vertical flex={1}>
        <Horizontal>
          <Vertical flex={1}>
            {isRefreshing ? (
              <Texto weight={600} align='right' className='flex' appearance='secondary'>
                <LoadingOutlined className='mr-2' /> Refreshing
              </Texto>
            ) : (
              <Texto weight={500} align='right' category='h6'>
                {addCommasToNumber(directive.weekly_allocation, 0)}
              </Texto>
            )}
          </Vertical>
          <Vertical flex={1}>
            {canEditDirectives ? (
              <ClickTextEdit
                display={
                  <Texto weight={500} align='right' category='h6' className='pr-2'>
                    {`${addCommasToNumber(directive.weekly_percent * 100, 0)}%`}
                  </Texto>
                }
                onSave={onSave}
                defaultValue={addCommasToNumber(directive.weekly_percent * 100, 0)}
              />
            ) : (
              <Texto weight={500} align='right' category='h6' className='pr-2'>
                {addCommasToNumber(directive.weekly_percent * 100, 0)}%
              </Texto>
            )}
          </Vertical>
          <Vertical className='pr-4' flex={1}>
            <Texto weight={500} align='right' category='h6'>
              {addCommasToNumber(directive.weekly_start_allocation, 0)}
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>
      <Horizontal flex={1}>
        <Tooltip title='Weekly Allocation Pace (Maximum)'>
          <div className='flex-1 flex'>
            <PaceMetric
              value={directive.weekly_contract_pace || 0}
              loaded={directive.weekly_loaded}
              allocation={directive.weekly_start_allocation}
              type='compact'
              letter='W'
            />
          </div>
        </Tooltip>
      </Horizontal>
    </Horizontal>
  )
}
